/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Phone_PlaceholderInputs */

const en_business_form_phone_placeholder = /** @type {(inputs: Business_Form_Phone_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 (555) 123-4567`)
};

const es_business_form_phone_placeholder = /** @type {(inputs: Business_Form_Phone_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+34 (555) 123-4567`)
};

/**
* | output |
* | --- |
* | "+1 (555) 123-4567" |
*
* @param {Business_Form_Phone_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_phone_placeholder = /** @type {((inputs?: Business_Form_Phone_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Phone_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_phone_placeholder(inputs)
	return en_business_form_phone_placeholder(inputs)
});